'use strict';

customerZone

.service('SettingsService', ['$q', 'Session', 'UnleashedClient', 'BudskapClient',  function($q, Session, api, budskap){

    var self = this;

    var BUDSKAP_FLAG = {
        GENERAL_COMMUNICATION: 'general_communication',
        COMMERCIAL_COMMUNICATION: 'commercial_communication',
        TRAFFIC_DATA_COMMUNICATION: 'allow_processing_traffic_data'
    };

    var BUDSKAP_FLAGS = Object.keys(BUDSKAP_FLAG).map(function(key){ return BUDSKAP_FLAG[key]; });


    /**
     * Get a complete view of all notification settings for the current user.
     *
     * @return a promise to an Object of which the keys are subscription msisdns, and the values are notification
     * settings.  The global settings are stored under the key '_'.
     */
    self.getNotificationSettings = function(){
        var subscribers = Session.subscribers();

        var result = {'_': []};

        var settingsPromises = [];

        // Note: Notifications via UWA are behind a switch because the backend implementation is unstable.
        // We can easily turn them back on in the future
        if (uwaNotificationsEnabled)
            settingsPromises = subscribers.map(function(subscriber){
                api.getNotificationSettings(subscriber.id)
                    .then(function(settings){
                        result[subscriber.msisdn] = settings;
                    });
            });

        if (uwaNotificationsEnabled)
            settingsPromises.push(api.getNotificationSettings()
                .then(function(settings){
                    [].push.apply(result['_'], settings);
                }));

        settingsPromises.push(getBudskapSettings()
            .then(function(settings){
                [].push.apply(result['_'], settings);
            }));

        return $q.all(settingsPromises).then(function(){
            return result;
        });
    };

    /**
     * Save all notification settings for a customer at once.
     *
     * @param settings The notification settings expressed as an object in which the keys are the msisdns of the
     * subscriptions whose settings to save.  The global settings (for the customer) should be under the key '_'.
     *
     * @return A promise that will resolve when all is saved.
     */
    self.saveNotificationSettings = function(settings){
        var savePromises = [];

        // Note: Notifications via UWA are behind a switch because the backend implementation is unstable.
        // We can easily turn them back on in the future
        if (uwaNotificationsEnabled)
            savePromises = Session.subscribers().map(function(subscriber){
                var subscriptionSettings = settings[subscriber.msisdn];
                if (!subscriptionSettings) return $q.when();
                return api.saveNotificationSettings(subscriptionSettings, subscriber.id);
            });

        var generalSettings = [];
        var budskapSettings = [];
        extractBudskap(settings['_'] || [], generalSettings, budskapSettings);

        if (uwaNotificationsEnabled && generalSettings.length > 0)
            savePromises.push(api.saveNotificationSettings(generalSettings));

        savePromises.push(budskap.setNotificationSettings(budskapSettings));

        return $q.all(savePromises);
    };

    self.setCommercialCommunication = function(value){
        var settings = [{name: BUDSKAP_FLAG.COMMERCIAL_COMMUNICATION, channels: {mail: !!value}}];
        return budskap.setNotificationSettings(settings);
    };

    self.getCommercialCommunication = function(){
        return budskap.getNotificationSettings()
            .then(function(settings){
                var commmercialCommunicationSetting = settings
                    .filter(function(setting){ return setting.name === BUDSKAP_FLAG.COMMERCIAL_COMMUNICATION; })[0];
                if (!commmercialCommunicationSetting) return false;
                return !!commmercialCommunicationSetting.channels.mail;
            });
    };

    self.setTrafficDataCommunication = function(value){
        var settings = [{name: BUDSKAP_FLAG.TRAFFIC_DATA_COMMUNICATION, channels: {mail: value}}];
        return budskap.setNotificationSettings(settings);
    };

    self.getTrafficDataCommunication = function(){
        return budskap.getNotificationSettings()
            .then(function(settings){
                return settings
                    .filter(function(setting){ return setting.name === BUDSKAP_FLAG.TRAFFIC_DATA_COMMUNICATION; })[0];
            });
    };

    var getBudskapSettings = function(){
        return budskap.getNotificationSettings()
            .then(function(settings) {
                return settings
                    .filter(function(entry){
                        return BUDSKAP_FLAGS.includes(entry.name);
                    }).map(function(entry){
                        return {name: 'budskap__' + entry.name, channels: {mail: entry.channels.mail}};
                    });
            });
    };

    var extractBudskap = function(settings, general, budskap){
        /**
         * Sort out the given settings into general settings and budskap settings.
         *
         * @param settings settings to sort out
         * @param general array to dump the general settings in
         * @param budskap array to dump the budskap settings in
         *
         * dev note: when moving to TS/ES6, we can change this into a function with
         * multiple returns.  Will be cleaner.
         */
        settings.forEach(function(setting){
            var budskapMatcher = /^budskap__(.*)$/.exec(setting.name);
            if (!budskapMatcher) general.push(setting);
            else budskap.push({name: budskapMatcher[1], channels: {mail: !!setting.channels.mail}});
        });
    };

    var uwaNotificationsEnabled = false;

    self.enableUwaNotifications = function(onOff){
        uwaNotificationsEnabled = onOff;
    };

}]);
